export default "__VITE_ASSET__vcM2Jstw__"